import Update from '../submit/update'

function UpdateEditPage() {
  return <Update isEdit />
}

export default UpdateEditPage
